import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/filter';
import {NgbModal, ModalDismissReasons, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

import { AuthService } from '../providers/auth.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { environment } from '../../environments/environment.prod';
@Component({
  selector: 'app-my-payment',
  templateUrl: './my-payment.component.html',
  styleUrls: ['./my-payment.component.css']
})
export class MyPaymentComponent implements OnInit {
  currentUser:any = {};
  laundering_options:any = [];
  paymentData:any = [];
  TIME_RANGE:any = [];
  DAYS: any = [];
  modalReference: any;
  invoiceData: any = {};
  priceType:any = {};
  p:any;
  
  constructor(private modalService: NgbModal,private auth : AuthService, private router: Router, private route: ActivatedRoute, private spinnerService: Ng4LoadingSpinnerService) { 
    this.priceType = { '1' : 'lb', '2' : 'ea', '3' : 'order'};
  }

  ngOnInit() {
    this.DAYS = environment.DAYS;
    this.TIME_RANGE = environment.TIME_RANGE;
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));

    let sid = localStorage.getItem('sid');
    let order = {"sid":sid}
    this.spinnerService.show();
    this.auth.laundering_options().then((user) => {
      console.log(user.json());
      let response = user.json();
      if(response.replyCode == "error"){
        this.spinnerService.hide();
        this.auth.open(response.replyMsg);
      }else{
        this.laundering_options = response.data;
        //this.spinnerService.hide();
        console.log("laundering_options", this.laundering_options)
      }
    })
    .then(()=>{
      this.auth.mypayment(order).then((order)=> {
        let response = order.json();
        if(response.replyCode == "error"){
          this.spinnerService.hide();
          this.auth.open(response.replyMsg);
        }else{
          this.paymentData = response.data;
          this.spinnerService.hide();
          console.log("paymentData", response.data)
        }
      })
    })
    .catch((err) => {
      this.spinnerService.hide();
      console.log(err);
      this.auth.open(environment.error)
    });
  }

  getTIME_RANGEtoValue(id = ''){
    var count = this.TIME_RANGE.length;
    for( var i = 0; i < count; i++ )
    { 
       if( (this.TIME_RANGE[i].id).toString() == id.toString() ){
           return (this.TIME_RANGE[i].val); 
       }
    }
    return '';  
  }  

  getDAYStoValue(id = ''){
    var count = this.DAYS.length;
    for( var i = 0; i < count; i++ )
    { 
       if( (this.DAYS[i].id).toString() == id.toString() ){
           return (this.DAYS[i].value); 
       }
    }
    return '';  
  }

  showChoosedServiceName(dc_require = 0,is_laundry=0){
    let str = '';
    if(dc_require){
      str = 'Dry Cleaning';
    }

    if(is_laundry){
      if (str=='') {
        str += 'Laundry';
      } else {
        str += ', Laundry';
      }
      
    }

    return str;  
  }

  getDitergenttoValue(id = ''){
    var count = ( this.laundering_options.detergents != undefined && this.laundering_options.detergents ) ? this.laundering_options.detergents.length : 0;
    for( var i = 0; i < count; i++ )
    { 
       if( (this.laundering_options.detergents[i].id).toString() == id.toString() ){
           return (this.laundering_options.detergents[i].title); 
       }
    }
    return '';  
  }

  getSoftenerstoValue(id = ''){
    var count = ( this.laundering_options.softeners != undefined && this.laundering_options.softeners ) ? this.laundering_options.softeners.length : 0;
    for( var i = 0; i < count; i++ )
    { 
       if( (this.laundering_options.softeners[i].id).toString() == id.toString() ){
           return (this.laundering_options.softeners[i].title); 
       }
    }
    return '';  
  }

  getWhitenerstoValue(id = ''){
    var count = ( this.laundering_options.whiteners != undefined && this.laundering_options.whiteners ) ? this.laundering_options.whiteners.length : 0;
    for( var i = 0; i < count; i++ )
    { 
       if( (this.laundering_options.whiteners[i].id).toString() == id.toString() ){
           return (this.laundering_options.whiteners[i].title); 
       }
    }
    return '';  
  }

  logout(){
    this.auth.changeLoginStatus(false);
    localStorage.removeItem('token');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('sid');
   this.router.navigate(['/']);
  }

  paidStatus(status){
   if(status=='6'){
     return "Paid";
   }else{
     return "Unpaid";
   }
  }

  openinvoice(content, invoiceOrder) {
    console.log(invoiceOrder);
    if(this.modalReference)
    this.modalReference.close();
    this.modalReference = this.modalService.open(content,  { windowClass: 'invoice-modal' });
    this.invoiceData = invoiceOrder;
  }

  getPriceTypeAbrv(index){
    return this.priceType[index];
  }
  makeRoundMultiply(first, second){
    //*ngIf="service.quantity?true:false"
    return  ( first * second ).toFixed(2);
  } 

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/my-payment/my-payment.component.ts